import { WarningAmberRounded as WarningAmberRoundedIcon } from '@mui/icons-material'
import { Avatar, MenuItem, Stack, Tooltip } from '@mui/material'
import React, { useCallback } from 'react'
import { T } from '@/helpers/T'
import { useUserAvatar } from '@/hooks/useUserAvatar'
import type { ISessionDetailed } from '@/modules/_misc/Session'
import { useAuthContext } from '@/providers/Global'

//	///////////////////////
//	MARK: TYPES
interface IProps {
  session: ISessionDetailed
}

//	///////////////////////
//	MARK: EXPORTS
const NavbarUserAnotherInternal: React.FC<IProps> = ({ session }) => {
  const Auth = useAuthContext()

  const avatar = useUserAvatar(session)

  const login = useCallback(() => {
    Auth.changeSession(session)
  }, [Auth, session])

  return (
    <MenuItem onClick={login}>
      <Avatar alt={session.user.fullName} src={avatar} sx={{ mr: 2 }} />
      <Stack direction='row' alignItems='center' spacing={1} sx={{ minWidth: 0 }}>
        <span>{session.user.fullName}</span>
        {session.impersonation && (
          <Tooltip title={<T id='r.impersonation.session_badge' />}>
            <WarningAmberRoundedIcon
              color='error'
              fontSize='small'
              sx={{ verticalAlign: 'middle' }}
            />
          </Tooltip>
        )}
      </Stack>
    </MenuItem>
  )
}

export const NavbarUserAnother = React.memo(
  NavbarUserAnotherInternal,
) as typeof NavbarUserAnotherInternal
